import { useQuery } from '@tanstack/react-query';
import eduzzAccountsService from 'v2/services/eduzzAccount';

export function useGetBlacklistEntries() {
  return useQuery({
    queryKey: ['blacklist-entries'],
    queryFn: () => eduzzAccountsService.getBlacklistEntries()
  });
}
